import { render } from "./AboutIcon.vue?vue&type=template&id=ca6ed0be&scoped=true"
import script from "./AboutIcon.vue?vue&type=script&lang=js"
export * from "./AboutIcon.vue?vue&type=script&lang=js"

import "./AboutIcon.vue?vue&type=style&index=0&id=ca6ed0be&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca6ed0be"]])

export default __exports__